import ProfitSharing from "@/views/editor/service/profit_sharing/profit_sharing/index";
import {INewBusiness} from "@/views/editor/service/business";

export default {'profit_sharing': ProfitSharing} as { [key: string]: INewBusiness }